<template>
  <listTemplate :class="'height__100vh'">
    <template #header>
      <headerTemplate>
        <template #filterByStatus>
          <!--          <div class="leftSection">-->
          <!--            <div class="header-title wrapper-content__main font-weight__bold">-->
          <!--              Văn bản đến chờ xử lý-->
          <!--            </div>-->
          <!--          </div>-->
          <filter-by-status-header
            ref="headerFilter"
            :filterStatus="filterStatus"
            :filterOptions="filterOptions"
            :title="'Văn bản đến chờ xử lý'"
            @filterByStatus="filterByStatus"
          />
        </template>
      </headerTemplate>
    </template>
    <template #view>
      <div class="view">
        <listTemplate :classCustom="'list-docs wrapper-content__main'">
          <template #subHeader>
            <subHeader>
              <template #content>
                <!--                <el-button-->
                <!--                  @click="exportSearchResult"-->
                <!--                  type="primary" >Xuất kết quả tìm kiếm</el-button>-->
                <div class="leftSection flex-row">
                  <el-button
                    size="medium"
                    type="primary"
                    class="btn___confirm"
                    @click="chuyenXuLyNhieuVBan()"
                    v-show="countVbanChecked > 0"
                  >
                    <div class="flex-row flex__center">
                      <i
                        class="fal fa-mail-bulk font-size__medium color__white"
                      ></i>
                      &nbsp;&nbsp;
                      <span>CHUYỂN XỬ LÝ </span>
                    </div>
                  </el-button>
                  <el-button
                    size="medium"
                    type="success"
                    class="btn___confirm"
                    @click="ketThucNhieuVBan()"
                    v-show="countVbanChecked > 0"
                  >
                    <div class="flex-row flex__center">
                      <i
                        class="fal fa-check-circle font-size__medium color__white"
                      ></i>
                      &nbsp;&nbsp;
                      <span>KẾT THÚC</span>
                    </div>
                  </el-button>
                </div>
                <div class="leftSection margin-left-10">
                  <!--                hoang xuất kêt quả tìm kiếm -->
                  <el-tooltip class="item" effect="dark" content="Kết xuất kết quả tìm kiếm" placement="top-end">
                    <el-button
                      size="medium"
                      @click="chosenFileType"
                      type="primary">
                      <div class="flex-row flex__center">
                        <i class="fas fa-file-export"></i>
                        <span>&nbsp;KẾT XUẤT</span>
                      </div>
                    </el-button>
                  </el-tooltip>
                </div>
                <searchTemplate
                  :keyword="keyword"
                  @simpleSearch="simpleSearch"
                  @search="isOpenAdvanceSearchDialog = true"
                >
                  <template #quickFilter>
<!--                    <div-->
<!--                      v-if="isEnableSoDuyetForUser"-->
<!--                      class="flex-row margin-right-25"-->
<!--                    >-->
<!--                      <span class="style-fullWidth label-input margin-right-10">Văn bản cần sơ duyệt: </span>-->
<!--                      <el-switch-->
<!--                        v-model="soDuyet"-->
<!--                        @change="filterBySoDuyet"-->
<!--                      >-->
<!--                      </el-switch>-->
<!--                    </div>-->
                    <div
                      v-if="isEnableSoDuyetForUser || isEnablePheDuyetForUser"
                      class="flex-row margin-right-25"
                    >
                      <el-radio-group v-model="duyetCXLFilter" size="mini" @change="filterBySoDuyet">
                        <el-radio-button label="1">Văn bản sơ duyệt</el-radio-button>
                        <el-radio-button label="2">Văn bản thông thường</el-radio-button>
                        <el-radio-button label="0" >Tất cả</el-radio-button>
                      </el-radio-group>
                    </div>

                    <div class="flex-row margin-right-25">
                      <span class="style-fullWidth label-input margin-right-10">Quan trọng: </span>
                      <input
                        style="display: none"
                        type="checkbox"
                        ref="starCheckbox"
                        v-model="isStar"
                      >
                      <div class="theTitle__star" @click="isStarChange">
                        <i :class="{'fas fa-star' : isStar, 'fal fa-star' : !isStar}" />
                      </div>
                    </div>
<!--                    <div-->
<!--                      class="flex-row flex-left__top margin-right-10 custom-label__input fix-width__large"-->
<!--                    >-->
<!--                      <span class="label-input width__auto">Ngày chuyển: </span>-->
<!--                      <el-date-picker-->
<!--                        v-model="sendTimeRange"-->
<!--                        type="daterange"-->
<!--                        format="dd/MM/yyyy"-->
<!--                        class="style-fullWidth input-border__bottom input-border__radius__0 bg__transparent"-->
<!--                        :picker-options="dateQuickFilterOption"-->
<!--                        range-separator="_"-->
<!--                        start-placeholder="_"-->
<!--                        end-placeholder="_"-->
<!--                        align="right"-->
<!--                        :clearable="false"-->
<!--                        @change="filterBySendTime"-->
<!--                      ></el-date-picker>-->
<!--                    </div>-->

                    <div class="flex-row flex-left__top margin-right-10 custom-label__input fix-width__large">
                      <span class="label-input width__auto"
                      >Ngày chuyển:
                      </span>
                      <span class="label-input width__auto">Từ ngày:</span>
                      <el-date-picker
                        v-model="fromSendTime"
                        type="date"
                        format="dd/MM/yyyy"
                        class="style-fullWidth input-border__bottom input-border__radius__0 bg__transparent"
                        placeholder="Chọn ngày bắt đầu"
                        align="right"
                        :clearable="false"
                        @change="filterBySendTime"
                      ></el-date-picker>
                    </div>

                    <div class="flex-row flex-left__top margin-right-10 custom-label__input fix-width__large">
                      <span class="label-input width__auto">Đến ngày:</span>
                      <el-date-picker
                        v-model="toSendTime"
                        type="date"
                        format="dd/MM/yyyy"
                        class="style-fullWidth input-border__bottom input-border__radius__0 bg__transparent"
                        placeholder="Chọn ngày kết thúc"
                        align="right"
                        :clearable="false"
                        @change="filterBySendTime"
                      ></el-date-picker>
                    </div>
                    <div class="margin-right-10 txt-center fix-width__small" style="width: 110px;">
                      <multiselect
                        :class="[
                          docReadStatusFilter ? '' : '',
                          'style-fullWidth'
                        ]"
                        :options="docReadStatusFilters"
                        label="name"
                        track-by="id"
                        v-model="docReadStatusFilter"
                        :preselect-first="true"
                        placeholder="-"
                        :multiple="false"
                        :close-on-select="true"
                        :clear-on-select="true"
                        :searchable="true"
                        open-direction="bottom"
                        @input="filterByDocReadStatus"
                      >
                        <template slot="singleLabel" slot-scope="{ option }">
                          <div
                            class="status-doc flex-row flex__left font-size__medium"
                          >
                            &nbsp;&nbsp;
                            <filter-icon-is-read-vban
                              :isRead="option.id"
                            ></filter-icon-is-read-vban>
                            <span>{{ option.name }}</span>
                          </div>
                        </template>
                      </multiselect>
                    </div>
                  </template>
                  <template #advance>
                    <vbden-advance-search-dialog
                      :isOpen="isOpenAdvanceSearchDialog"
                      :form="advanceSearchForm"
                      v-if="isEnableAdvanceSearchDialog"
                      @dialogClosed="isEnableAdvanceSearchDialog = false"
                      @closeDialog="isOpenAdvanceSearchDialog = false"
                      @doSearch="advanceSearch"
                    />
                  </template>
                </searchTemplate>
              </template>
            </subHeader>
          </template>

          <template #body>
            <transition name="fade-in">
              <div class="list">
                <!-- header-title -->
                <div
                  class="header-title flex-row flex__between margin-bottom-10"
                >
                  <div class="leftSection flex-row flex__left">
                    <transition name="fade-in">
                      <div :class="['theTitle theTitle__lv5 theTitle--hasStar']">
                        <span
                          class="stt margin-left-10"
                          v-show="!hasExistChecked"
                        >STT</span
                        >
                        <div
                          :class="['flex-row flex__center checkbox']"
                          v-show="hasExistChecked"
                        >
                          <el-checkbox
                            :class="['checkboxVBan']"
                            v-model="checkAll"
                            @change="checkAllVBan"
                          ></el-checkbox>
                        </div>
                      </div>
                    </transition>
                    <div
                      class="theTitle theTitle__lv1 flex-row flex__left clickable"
                      @click="doSort('quote')"
                    >
                      Trích yếu
                      <sort-caret
                        :order="order"
                        :sort="sort"
                        :field="'quote'"
                      />
                    </div>
                  </div>
                  <div class="rightSection flex-row flex__right">
                    <div
                      class="theTitle theTitle__lv3 flex-row flex__left padding-left-10 clickable"
                      @click="doSort('docDate')"
                    >
                      Ngày văn bản
                      <sort-caret
                        :order="order"
                        :sort="sort"
                        :field="'docDate'"
                      />
                    </div>
                    <div
                      class="theTitle theTitle__lv2 flex-row flex__left padding-left-10"
                      @click="doSort('senderName')"
                    >
                      Người chuyển
                      <sort-caret
                        :order="order"
                        :sort="sort"
                        :field="'senderName'"
                      />
                    </div>
                    <div
                      class="theTitle theTitle__lv3 flex-row flex__left padding-left-10 clickable"
                      @click="doSort('sendTime')"
                    >
                      Thời gian chuyển
                      <sort-caret
                        :order="order"
                        :sort="sort"
                        :field="'sendTime'"
                      />
                    </div>
                    <div
                      class="theTitle theTitle__lv3 flex-row flex__left padding-left-10 clickable"
                      @click="doSort('deadlineDate')"
                    >
                      Hạn xử lý
                      <sort-caret
                        :order="order"
                        :sort="sort"
                        :field="'deadlineDate'"
                      />
                    </div>
                  </div>
                </div>
                <!-- list-docs -->
                <VuePerfectScrollbar
                  class="scroll-area"
                  :settings="perfectScrollbarSetting"
                  infinite-wrapper
                >
                  <div class="list-docs">
                    <div
                      v-for="(item, $itemIndex) in incomingDocs"
                      v-bind:key="$itemIndex"
                      :class="[
                        'item flex-row flex__between',
                        !item.isSeen ? 'is-seen' : ''
                      ]"
                      @click="viewDetail(item)"
                    >
                      <div class="leftSection flex-row flex__left">
                        <div class="theTitle__lv5 theTitle--hasStar flex-row">
                          <div
                            class="flex-row flex__left stt"
                            v-show="!hasExistChecked"
                          >
                            <div class="section-check">
                              <span class="stt flex-row flex__center">{{
                                  $itemIndex + 1
                                }}</span>
                            </div>
                            <i
                              @click.stop="
                                downloadAttachment(
                                  item,
                                  ATTACHMENT_OBJECT_TYPE.VB_DEN
                                )
                              "
                              class="clickable color__smoke fas fa-file"
                            ></i>
                          </div>
                          <div
                            :class="[
                              'checkbox',
                              hasExistChecked ? '' : 'hover'
                            ]"
                          >
                            <el-checkbox
                              :class="['checkboxVBan']"
                              v-model="item.checkVBan"
                              @click.stop.native="() => true"
                              @change="checked"
                            ></el-checkbox>
                          </div>
                          <div class="theTitle__star">
                            <i
                              :class="{'fal fa-star': !item.isStar, 'fas fa-star': item.isStar}"
                              @click.stop="changeStar(item)"
                            ></i>
                          </div>
                        </div>
                        <div class="theTitle__lv1 margin-right-10">
                          <div class="title-docs flex-col flex__left">
                            <div
                              class="tt_1 clickable"
                              v-bind:class="textBold(item)"
                            >
                              {{ item.quote }}
                            </div>
                            <div class="tt_2 flex-row flex__left margin-top-10">
                              <span v-if="item.docCode"
                              >{{ item.docCode }}&nbsp;&nbsp;</span
                              >
                              <el-tag
                                v-if="item.docTypeName"
                                size="mini"
                                :class="['priority', 'lv3']"
                              >{{ item.docTypeName }}
                              </el-tag>

                              <el-tag
                                v-if="isShowPriority(item.priorityId)"
                                size="mini"
                                :class="[
                                  'priority',
                                  getPiorityClass(item.priorityId)
                                ]"
                              >
                                <i class="fas fa-bolt"></i>
                                <span>
                                  {{ item.priorityName }}
                                </span>
                              </el-tag>

                              <vb-process-type-tag
                                v-if="item.vbDocProcessType != null"
                                :processType="item.vbDocProcessType"
                              ></vb-process-type-tag>

                              <el-tag size="mini" style="margin-left: 5px;" v-if="item.userId != userId" >
                                  <i class="fas fa-info"></i>
                                <span>
                                  VB đến lãnh đạo
                                </span>
                              </el-tag>

                              <el-tag
                                size="mini"
                                class="priority lv2"
                                v-if="isAutoBcc(item)"
                              >
                                <i class="fas fa-exclamation-triangle"></i>
                                {{ item.vbDocBccInfoId ? "BCC-DT" : "BCC" }}
                              </el-tag>
                              <span>
                                <el-tooltip
                                  content="Văn bản điện tử"
                                  placement="top"
                                  effect="dark"
                                  v-if="isVbDienTu(item)"
                                >
                                  <div class="eIcon">e</div>
                                </el-tooltip>
                              </span>
                              <span>
                                <el-tooltip
                                  content="Đã ban hành bản giấy"
                                  placement="top"
                                  effect="dark"
                                  v-if="item.isBanHanhBanGiay"
                                >
                                  <div class="eIcon">p</div>
                                </el-tooltip>
                              </span>
                              <span>
                               <el-tooltip
                                 content="Không có tài liệu đính kèm"
                                 placement="top"
                                 effect="dark"
                                 v-if="item.isNotFileDinhKem"
                               >
                                 <div class="eIcon">p</div>
                               </el-tooltip>
                            </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="rightSection flex-row flex__right">
                        <div
                          class="theTitle__lv3 flex-row flex__left padding-left-10 font-size__small"
                        >
                          <div class="flex-row flex__right txt-right">
                            <i class="cellIcon color__silver fas fa-clock"></i>
                            {{
                              item.docDate
                                | dateFormatter({
                                nullValue: "-",
                                dateFormat: "DD/MM/YYYY"
                              })
                            }}
                          </div>
                        </div>

                        <div
                          class="theTitle__lv2 flex-row flex__left padding-left-10 font-size__small"
                        >
                          <div class="flex-row flex__left">
                            <displayPeople :name="item.senderName"/>
                          </div>
                        </div>

                        <div
                          class="theTitle__lv3 flex-row flex__left padding-left-10 font-size__small"
                        >
                          <quahan-time :time="item.sendTime"></quahan-time>
                        </div>

                        <div
                          class="theTitle__lv3 flex-row flex__left padding-left-10 font-size__small"
                        >
                          <quahan-time :time="item.deadlineDate"></quahan-time>
                        </div>

                        <div
                          class="theQuickAction flex-row flex__right"
                        >
                          <el-tooltip content="In phiếu xử lý" placement="top">
                            <i
                              @click.stop="inPhieuTrinhKi(item)"
                              class="action-icon bgAmbient__green clickable fas fa-print"
                            ></i>
                          </el-tooltip>
                          <el-tooltip content="Chuyển xử lý" placement="top" v-if="!isAutoBcc(item)">
                            <i
                              @click.stop="chuyenXuLy(item)"
                              class="action-icon bgAmbient__blue clickable fas fa-arrow-alt-to-right"
                            ></i>
                          </el-tooltip>
                        </div>
                      </div>
                    </div>

                    <infinite-loading
                      v-if="hasLoadedIsSoDuyet"
                      ref="infiniteLoading"
                      spinner="spiral"
                      @infinite="infiniteHandler"
                    >
                      <div slot="no-more"></div>
                      <div slot="no-results">Không có dữ liệu</div>
                    </infinite-loading>
                  </div>
                </VuePerfectScrollbar>
              </div>
            </transition>
          </template>
        </listTemplate>

        <!-- dialog ket thuc -->
        <DocOutKetThuc
          title="Kết thúc nhiều văn bản"
          :isOpen="isOpenKetThucDialog"
          :objects="objects"
          v-if="isEnableKetThucDialog"
          @closed="isEnableKetThucDialog = false"
          @closeDialog="isOpenKetThucDialog = false"
          @success="ketThucSuccess"
        />

        <!--        <Transfer-->
        <!--          :isOpen="isOpenTransferDialog"-->
        <!--          :incomingProcessId="selectedDoc.vbDocUserVbDocProcessId"-->
        <!--          :isEnableCXLDonVi="true"-->
        <!--          :isEnableCXLCaNhan="true"-->
        <!--          :quote="selectedDoc.quote"-->
        <!--          v-if="isEnableTransferDialog"-->
        <!--          @closed="isEnableTransferDialog = false"-->
        <!--          @closeDialog="isOpenTransferDialog = false"-->
        <!--          @success="chuyenXuLiSuccess"-->
        <!--        />-->

        <cxl-vbden-dialog
          :isOpen="isOpenTransferDialog"
          :quote="selectedDoc.quote"
          :incomingProcessId="selectedDoc.vbDocUserVbDocProcessId"
          :vbStep="vbStep"
          v-if="isEnableTransferDialog"
          @closed="isEnableTransferDialog = false"
          @closeDialog="isOpenTransferDialog = false"
          @success="chuyenXuLiSuccess"
        />

        <tuChoiDialog
          :isOpen="isOpenTuChoiDialog"
          :vbIncomingDocId="userVbIncomingProcessId"
          v-if="isEnableTuChoiDialog"
          @dialogClosed="isEnableTuChoiDialog = false"
          @closeDialog="isOpenTuChoiDialog = false"
          @success="tuChoiSuccess"
        />
        <chosen-file-type-dialog
          v-if="isOpenChosenFileTypeDialog"
          @closeDialog="isOpenChosenFileTypeDialog= false"
          @exportResult="exportResult"
          :is-open="true">
        </chosen-file-type-dialog>

        <!-- chuyen xu ly nhieu van ban -->
        <transition name="el-fade-in-linear" mode="in-out">
          <ProcessChuyenXuLyNhieuVB
            :isOpen="isOpenTransferMultipleVbanDialog"
            :listIncomingDocInput="listIncomingDoc"
            v-if="
              isEnableTransferMultipleVbanDialog &&
                isOpenTransferMultipleVbanDialog
            "
            @closed="isEnableTransferMultipleVbanDialog = false"
            @closeDialog="isOpenTransferMultipleVbanDialog = false"
            @success="chuyenXuLiSuccess"
          />
        </transition>
      </div>
    </template>
  </listTemplate>
</template>
<script>
import dateFormatter from "../../filters/dateFormatter";
import constants from "../../constants";
import BreakWordSpan from "../adminstration/ketluan/break-word-span";
import listTemplate from "../common/list";
import headerTemplate from "../../components/header/main-header.vue";
import searchTemplate from "../common/search";
import vbDenMixin from "./vbDenMixin";
import utils from "../../services/utils";
import {EventBus} from "../../event-bus.js";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import DocOutKetThuc from "./components/DocOutKetThuc";
import CxlVbdenDialog from "./components/cxl-vbden-dialog";
import FilterByStatusHeader from "../doc-out/components/filter-by-status-header";
import QuahanTime from "../doc-out/quahan-time";
import VbdenAdvanceSearchDialog from "./components/vbden-advance-search-dialog";
import FilterIconIsReadVban from "../common/filterIconIsReadVban";
import VbProcessTypeTag from "./vb-process-type-tag";
import chosenFileTypeDialog from "../doc-out/chosenFileTypeDialog";
import vbStepService from "../../services/vbStepService";
import vbStepInfoService from "../../services/vbStepInfoService";

export default {
  components: {
    chosenFileTypeDialog,
    BreakWordSpan,
    VbProcessTypeTag,
    FilterIconIsReadVban,
    VbdenAdvanceSearchDialog,
    QuahanTime,
    FilterByStatusHeader,
    CxlVbdenDialog,
    InfiniteLoading: () => import("vue-infinite-loading"),
    DocOutKetThuc,
    listTemplate,
    headerTemplate,
    searchTemplate,
    VuePerfectScrollbar,
    subHeader: () => import("../../components/main/sub-header.vue"),
    createDialog: () => import("./components/CreateDialog.vue"),
    filterByStatus: () => import("./components/filter-by-status-header.vue"),
    SortCaret: () => import("../doc-out/SortCaret"),
    tuChoiDialog: () => import("./components/tuChoiDialog"),
    ProcessChuyenXuLyNhieuVB: () =>
      import("./components/processChuyenXuLyNhieuVB"),
    displayPeople: () => import("../common/displayPeople.vue")
  },

  filters: {dateFormatter},
  mixins: [vbDenMixin],

  data() {
    return {
      isOpenChosenFileTypeDialog: false,
      sortList: [],
      ATTACHMENT_OBJECT_TYPE: constants.ATTACHMENT_OBJECT_TYPE,
      listIncomingDoc: [],
      objects: [],
      countVbanChecked: 0,
      checkAll: false,

      isOpenTransferMultipleVbanDialog: false,
      isEnableTransferMultipleVbanDialog: false,

      isOpenKetThucDialog: false,
      isEnableKetThucDialog: false,

      userVbIncomingProcessId: null,
      vbAttachment: {},
      isOpenTuChoiDialog: false,
      isEnableTuChoiDialog: false,
      isOpenTransferDialog: false,
      isEnableTransferDialog: false,
      selectedDoc: null,
      STEP_POS_TYPE: constants.STEP_POS_TYPE,
      docReadStatusFilters: [
        {id: null, name: "Tất cả"},
        {
          id: constants.READ_STATUS.UN_READ,
          name: "Chưa đọc"
        },
        {
          id: constants.READ_STATUS.READED,
          name: "Đã đọc"
        }
      ],
      filterOptions: [
        {
          value: constants.VBDEN_CHOXULY_PAGE.FILTER.ALL,
          label: "Tất cả",
          iconClass: null
        },
        {
          value: constants.VBDEN_CHOXULY_PAGE.FILTER.CHU_TRI,
          label: "Chủ trì",
          iconClass: "fa-user"
        },
        {
          value: constants.VBDEN_CHOXULY_PAGE.FILTER.PHOI_HOP,
          label: "Phối hợp",
          iconClass: "fa-users"
        },
        {
          value: constants.VBDEN_CHOXULY_PAGE.FILTER.NHAN_DE_BIET,
          label: "Nhận để biết",
          iconClass: "fa-info"
        }
      ],
      vbStep: null,
      VB_DOC_USER: constants.VB_DOC_USER,
      isEnableSoDuyetForUser: false,
      isEnablePheDuyetForUser: false,
      hasLoadedIsSoDuyet: false
    };
  },

  computed: {
    status() {
      return [constants.DOC_USER_STATUS.CHO_XU_LY];
    },

    currentRoute() {
      return this.$route.path.split("/")[3];
    },

    hasExistChecked() {
      return this.countVbanChecked > 0;
    },
    userId() {
      return this.$store.getters.userDeptRole.userId;
    },
  },

  watch: {
    isOpenTransferDialog(newValue) {
      newValue && (this.isEnableTransferDialog = newValue);
    },

    isEnableTransferDialog(newValue) {
      !newValue && (this.selectedDoc = null);
    },

    isOpenTuChoiDialog(newValue) {
      newValue && (this.isEnableTuChoiDialog = newValue);
    },

    isOpenKetThucDialog(newValue) {
      newValue && (this.isEnableKetThucDialog = newValue);
    },
    isOpenTransferMultipleVbanDialog(newValue) {
      newValue && (this.isEnableTransferMultipleVbanDialog = newValue);
    }
  },

  async created() {
    this.sort = this.$route.query.sort || "sendTime";
    this.order = this.$route.query.order || "desc";
    this.initQuery();
    // this.initSendTimeRange();
    this.setDefaultDocDateRange();
    this.filterBySendTime();
    await this.loadIsEnableSoDuyetForUser();
    this.loadIsEnablePheDuyetForUser();
  },

  mounted() {
    console.log('mounted ...')
    EventBus.$on(this.currentRoute, options => {
      this.isOpenDialogCreate = false;
      this.doSearch();
    });
  },

  methods: {
    loadIsEnableSoDuyetForUser() {
      return vbStepInfoService.isEnableSoDuyetForUser()
      .then(res => {
        this.isEnableSoDuyetForUser = res.data;
        if (this.isEnableSoDuyetForUser) {
          this.advanceSearchForm.duyetCXLFilter = this.duyetCXLFilter;
        }
        this.hasLoadedIsSoDuyet = true
      });
    },

    loadIsEnablePheDuyetForUser() {
      return vbStepInfoService.isEnablePheDuyetForUser()
        .then(res => {
          this.isEnablePheDuyetForUser = res.data;
          if (this.isEnablePheDuyetForUser) {
            this.advanceSearchForm.duyetCXLFilter = this.duyetCXLFilter;
          }
          this.hasLoadedIsSoDuyet = true
        });
    },

    isVbDienTu(item) {
      if(item.eFlag&&item.eFlag==='1'){
        return true;
      }else {
        return false;
      }
    },
    chosenFileType() {
      this.isOpenChosenFileTypeDialog = true
    },
    exportResult(item) {
      this.isOpenChosenFileTypeDialog = false
      this.exportSearchResult(item, 'VB_DEN_CHO_XU_LY')
    },
    inPhieuTrinhKi(item) {
      let baseServiceURL = constants.BASE_SERVICE_URL;
      let reportUrl = constants.IN_PHIEU.VB_DEN;
      window.open(
        `${baseServiceURL}${reportUrl}?${utils.serialize({docId: item.docId})}`,
      );
    },
    isAutoBcc(item) {
      return (
        item.relationType === constants.VB_DOC_USER.RELATION_TYPE.NGUOI_DUOC_BCC
      );
    },

    filterByDocReadStatus(event) {
      this.advanceSearchForm.isRead = event.id === null ? undefined : event.id;
      this.doSearch();
    },

    advanceSearch(event) {
      this.advanceSearch_(event);
      this.initSendTimeRange();
      this.doSearch();
    },

    ketThucSuccess() {
      this.listIncomingDoc = this.incomingDocs = [];
      this.countVbanChecked = 0;
      this.checkAll = false;
      this.$message({
        message: "Kết thúc văn bản thành công",
        type: "success"
      });
      this.isOpenKetThucDialog = false;
    },

    checked(value) {
      this.countVbanChecked += value ? 1 : -1;
      this.checkAll = this.countVbanChecked === this.incomingDocs.length;
      let listChecked = this.incomingDocs.filter(doc => doc.checkVBan);
      this.listIncomingDoc = this.incomingDocs.filter(doc => doc.checkVBan);
      this.objects = listChecked.map(doc => {
        return {
          docId: doc.docId,
          processId: doc.vbDocUserVbDocProcessId
        };
      });
    },

    checkAllVBan(value) {
      !value && (this.countVbanChecked = 0);
      this.incomingDocs.forEach(item => {
        if (value) {
          this.$set(item, "checkVBan", value);
          this.countVbanChecked += 1;
        } else if (!value) {
          this.$set(item, "checkVBan", value);
        }
      });
      let listChecked = this.incomingDocs.filter(doc => doc.checkVBan);
      this.objects = listChecked.map(doc => {
        return {
          docId: doc.docId,
          processId: doc.vbDocUserVbDocProcessId
        };
      });
      this.listIncomingDoc = this.incomingDocs.filter(doc => doc.checkVBan);
    },

    chuyenXuLyNhieuVBan() {
      if (this.listIncomingDoc.length === 0) {
        this.message("Thông báo", "Chưa chọn văn bản !", "warning", 2000);
        return;
      }
      this.isOpenTransferMultipleVbanDialog = true;
    },

    ketThucNhieuVBan() {
      if (this.listIncomingDoc.length === 0) {
        this.message("Thông báo", "Chưa chọn văn bản !", "warning", 2000);
        return;
      }
      this.isOpenKetThucDialog = true;
    },

    viewDetail(item) {
      item.isSeen = 1;
      let query = utils.merge(this.$route.query, {
        vbDocProcessId: item.vbDocUserVbDocProcessId,
        isAssistantSign: item.userId != this.userId ? 1 : 0
      });
      let params = utils.merge(this.$route.params, {
        id: item.vbIncomingDocUserViewKey.id
      });
      this.$router.push({
        name: "vbDenChoXuLyDetail",
        params: params,
        query: query
      });
    },

    chuyenXuLy(item) {
      this.selectedDoc = item;

      vbStepService.findById(item.vbStepId)
      .then(response => {
        this.vbStep = response.data
        this.isOpenTransferDialog = true;
      });
    },

    chuyenXuLiSuccess(event) {
      this.listIncomingDoc = [];
      this.countVbanChecked = 0;
      this.isOpenTransferDialog = false;
      this.isOpenTransferMultipleVbanDialog = false;
      this.doSearch();
    },

    tuChoiSuccess(event) {
      this.isOpenTuChoiDialog = false;
      this.incomingDoc = event.vbIncomingDoc;
    }
  }
};
</script>
<style scoped>
#searchBox {
  position: relative;
  width: 100%;
}

.advance-search {
  font-size: 17px;
  color: #005eb1;
  position: absolute;
  right: 5%;
  top: 50%;
  transform: translateY(-50%);
}

.icon-very__small {
  height: 14px;
  padding-top: 4px;
}

.icon-info {
  background-color: #f0c330;
  border-radius: 50%;
  width: 15px;
  height: 15px;
  margin-top: -1px;
  margin-left: 2px;
}

.fade-in-enter-active,
.fade-in-leave-active {
  transition: opacity 1.5s;
}

.fade-in-enter, .fade-in-leave-to /* .fade-leave-active below version 2.1.8 */
{
  opacity: 0;
}

.item .checkbox.hover {
  display: none;
}

.item:hover .stt {
  display: none;
  transition: 0.5s;
}

.item:hover .checkbox.hover {
  display: flex;
  transition: 0.5s;
}

.eIcon {
  border: solid 1px #007aff;
  border-radius: 2px;
  padding: 0px 3px;
  font-size: 11px;
  color: goldenrod;
  margin-left: 2px;
}

.theTitle--hasStar .checkbox {
  margin: 0 12px 0 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/doc-in/vbDenChoXuLyIndex.vue